import gql from "../gql";
import LockedStamps from "../fragments/LockedStamps";
export default gql `
  query LockedStamps($slug: String!, $first: Int, $after: String) {
    lockedStamps(slug: $slug, first: $first, after: $after) {
      ...LockedStamps
    }
  }
  ${LockedStamps}
`;
